import moment from 'moment';
import genericTableService from '../genericConfig/genericTable.utils.js';
import comparableUtils from '@/services/propertyComparables/comparable.utils.js';

export default {
  getCurrentBreakOption(comparable, internalField) {
    const breakOptions = genericTableService.getGenericTableDataFromModel('BreakOptions', comparable);
    const breakOptionsInTheFuture = breakOptions.filter(({ LeaseBreakOption1Date }) => moment(LeaseBreakOption1Date).format() > moment().format());
    const breakOptionsInTheFutureSortByDateAsc = breakOptionsInTheFuture.sort(({ LeaseBreakOption1Date: a }, { LeaseBreakOption1Date: b }) => {
      if (a === null) {
        return 1;
      } else if (b === null) {
        return -1;
      } else {
        new Date(a) - new Date(b);
      }
    });

    return breakOptionsInTheFutureSortByDateAsc.length ? breakOptionsInTheFutureSortByDateAsc[0][internalField] : null;
  },

  /**
   * 
   * @param {Model} comparable 
   * @param {*} internalField 
   * @returns Retorna el PRIMER calculo de Annualized Base Rent que se ha introducido
   * esta tabla la vemos en el profile de LEASE en la instancia de CA.
   */
  getValueFromAnnualizedBaseRent(comparable, internalField) {
    const baseRentTableProfile = genericTableService.getGenericTableDataFromModel('LeaseTerm', comparable);
    const leasedArea = comparableUtils.getFieldValueFromComp(comparable, 'SFLeased', 'en');
    const result = Number(baseRentTableProfile[0]?.BaseRent * leasedArea);

    if (Number.isNaN(result)) {
      return;
    }

    return result;
  },

};
